var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "u-uploadMulti" },
    [
      _c(
        "div",
        { staticClass: "viewList" },
        [
          _vm._l(_vm.urlList, function (file, index) {
            return _c(
              "div",
              { key: index, staticClass: "previewItem" },
              [
                _c("MyImage", { staticClass: "img", attrs: { src: file.url } }),
                _vm._v(" "),
                _c("span", { staticClass: "actions" }, [
                  _c(
                    "span",
                    {
                      staticClass: "act previewBtn",
                      on: {
                        click: function ($event) {
                          return _vm.handlePictureCardPreview(file)
                        },
                      },
                    },
                    [_c("i", { staticClass: "el-icon-zoom-in" })]
                  ),
                  _vm._v(" "),
                  !_vm.isDisabled
                    ? _c(
                        "span",
                        {
                          staticClass: "act deleteBtn",
                          on: {
                            click: function ($event) {
                              return _vm.handleRemove(file)
                            },
                          },
                        },
                        [_c("i", { staticClass: "el-icon-delete" })]
                      )
                    : _vm._e(),
                ]),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "el-upload",
            _vm._b(
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.isLoading,
                    expression: "isLoading",
                  },
                ],
                ref: "uploadRef",
                staticClass: "uploadComp",
                class: {
                  hideAdd:
                    _vm.isDisabled ||
                    (_vm.limit && _vm.urlList.length >= _vm.limit),
                },
                attrs: {
                  action: "",
                  multiple: "",
                  "auto-upload": false,
                  "show-file-list": false,
                  limit: _vm.limit,
                  disabled: _vm.isDisabled,
                  "on-change": _vm.uploadData,
                  "on-exceed": _vm.onExceed,
                },
              },
              "el-upload",
              _vm.$attrs,
              false
            ),
            [
              _c(
                "div",
                {
                  staticClass: "uploadBtn",
                  attrs: { slot: "default" },
                  slot: "default",
                },
                [_c("i", { staticClass: "el-icon-plus" })]
              ),
            ]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("MyImage", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.dialogImageUrl },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }